<div class="api-key-container">
  <!-- <div class="action-section"> TODO: Add back in when we can handle multiple keys on the backend
   <mat-form-field appearance="outline">
      <mat-icon matPrefix class="xs">search</mat-icon>
      <input test-id="search-field" matInput
      [formControl]="nameFilter"
      [placeholder]="'common.actions.search' | translate"/>
    </mat-form-field>
  </div> -->
  <mat-table *ngIf="!loading; else loadingState" [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="label">
      <mat-header-cell *matHeaderCellDef>{{ 'common.labels.name' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let key" test-id="name">
        <mat-icon *ngIf="key.key !== legacyKey?.key" class="xs">key</mat-icon>
        <mat-icon *ngIf="key.key === legacyKey?.key" class="warning xs">warning</mat-icon>
        <p>{{ key.label }}</p>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="created">
      <mat-header-cell *matHeaderCellDef>{{ 'fwApiKeyTable.headers.generated' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let key" test-id="generated">{{ key.createdLabel }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="expires">
      <mat-header-cell *matHeaderCellDef>{{ 'fwApiKeyTable.headers.expires' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let key" test-id="expires" [ngClass]="{'red': key.expireWarning}">
        <span class="expiry" [matTooltip]="key.expiredTooltip" matTooltipPosition="right">
          {{ key.expiresLabel }} <mat-icon class="xs" *ngIf="key.expireWarning">error_outline</mat-icon>
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="last_used">
      <mat-header-cell *matHeaderCellDef>{{ 'fwApiKeyTable.headers.lastUsed' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let key" test-id="last-used">{{ key.lastUsedLabel }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let key">
        <button test-id="delete-button" mat-icon-button (click)="delete(key)">
          <mat-icon *ngIf="key.key !== legacyKey?.key">delete</mat-icon>
          <mat-icon *ngIf="key.key === legacyKey?.key">open_in_new</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div>

<div *ngIf="!loading && dataSource.data.length === 0" class="empty blank-state">
  <mat-icon class="sm raised blue">block</mat-icon>
  <p>{{ 'fwApiKeyTable.noData' | translate }}</p>
</div>

<ng-template #legacyDeletionDialog>
  <span class="legacy-deletion-content">
    <span class="section depreciating-api-warning">
      <mat-icon class="xs">warning</mat-icon>
      <span>
        <div class="title">{{ 'fwApiKeyTable.headers.deprecatingApi' | translate }}</div>
        <p [innerHTML]="'fwApiKeyTable.legacyWarning' | translate | trusthtml"></p>
      </span>
    </span>
    <span class="section">
      <div class="title">{{ 'fwApiKeyTable.yourApiKey' | translate }}</div>
      <mat-form-field appearance="outline">
        <input matInput readonly [type]="showKey ? 'text' : 'password'" [(ngModel)]="legacyApiKey">
        <mat-icon matSuffix (click)="showKey = !showKey">{{ showKey ? 'visibility_off' : 'visibility' }}</mat-icon>
      </mat-form-field>
    </span>
    <span class="section">
      <div class="title">{{ 'common.labels.flywheelCli' | translate }}</div>
      <p>{{ 'fwApiKeyTable.cliDesc' | translate }}</p>
      <mat-form-field appearance="outline">
        <input matInput readonly [type]="showTerminalCommand ? 'text' : 'password'" [(ngModel)]="legacyApiKeyLoginCommand">
        <mat-icon matSuffix (click)="showTerminalCommand = !showTerminalCommand">{{ showTerminalCommand ? 'visibility_off' : 'visibility' }}</mat-icon>
      </mat-form-field>
    </span>
    <span>
      <button mat-flat-button [mat-dialog-close]="true" color="warn"><mat-icon class="xs">delete</mat-icon>{{ 'fwApiKeyTable.revokeApiKey' | translate }}</button>
    </span>
  </span>
</ng-template>

<ng-template #loadingState>
  <div test-id="loading-state" class="blank-state">
    <img src="/assets/images/loading.svg" style="margin-bottom:10px">
    <p>{{ 'fwApiKeyTable.loadingApiKeys' | translate }}</p>
  </div>
</ng-template>
